module.exports = __webpack_public_path__ + "06534364cc7c3f2908fdae31fb17b35c.svg";